import { memo } from "react";

import { Video } from "@shopify/hydrogen-react";

import { type CartMediaVideo } from "@tablescape/state";
import { tw } from "classnames";

type Props = {
  ariaLabel: string;
  video: CartMediaVideo;
};

const styles = {
  wrapper: tw("bg-background-secondary", "aspect-square"),
  video: tw("block", "h-full", "w-full", "object-cover"),
};

const ProductGalleryGridVideoBase = ({ ariaLabel, video }: Props) => {
  return (
    <div className={styles.wrapper}>
      <Video
        aria-label={ariaLabel}
        autoPlay
        className={styles.video}
        controls={false}
        data={{
          mediaContentType: "VIDEO",
          sources: video.sources,
        }}
        data-chromatic="ignore"
        height={374}
        loop
        muted
        playsInline
        preload="none"
        width={374}
      />
    </div>
  );
};

export const ProductGalleryGridVideo = memo(ProductGalleryGridVideoBase);
